import AdebifyLtvDetailReducer from './reducers';

export default AdebifyLtvDetailReducer;
